import { Application } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

import { registerCommonControllers } from '@foxhound-systems/yesod-ui/controllers';
import { FormFinePrintController } from './controllers/form_fine_print_controller';
import { FormEnhancementsController } from './controllers/form_enhancements_controller.js';
import { MaskedInputController } from './controllers/masked_input_controller';
import { RequiredRepeaterController } from './controllers/required_repeater_controller.js';
import { ConfirmationController } from './controllers/confirmation_controller.js';
import { NavigationController } from './controllers/navigation_controller.js';
import { ClipboardController } from './controllers/clipboard_controller.js';
import { DialogController } from './controllers/dialog_controller.js';
import { LinkifyController } from './controllers/linkify_controller.js';
import { RepeaterController } from './controllers/repeater_controller.js';
import { DatepickerController } from './controllers/datepicker_controller.js';
import { TimeslotsController } from './controllers/timeslots_controller.js';
import { TimeInputController } from './controllers/time_input_controller.js';
import { ImageSelectorController } from './controllers/image_selector_controller.js';
import { FrameDialogController } from './controllers/frame_dialog_controller.js';
import { MenuTypeController } from './controllers/menu_type_controller.js';
import { AutoRedirectController } from './controllers/auto_redirect_controller.js';
import { TsidDecoderController } from './controllers/tsid_decoder_controller.js';
import { AllergyDetailsController } from './controllers/allergy_details_controller.js';
import { ResizableTextareaController } from './controllers/resizable_textarea_controller.js';
import { ZipCodeCityController } from './controllers/zip_code_city_controller.js';
import { BulkActionsController } from './controllers/bulk_actions_controller.js';
import { AutoSubmitController } from "./controllers/auto_submit_controller.js";
import { ChipPickerController } from './controllers/chip_picker_controller.js';
import { DateRangeBoxController } from './controllers/date_range_box_controller.js';
import { InviteBookingController } from './controllers/invite_booking_controller.js';
import { InviteFeedbackController } from './controllers/invite_feedback_controller.js';
import { InviteDeclineController } from './controllers/invite_decline_controller.js';
import { SendTimeController } from "./controllers/send_time_controller.js";


(() => {
    document.addEventListener("wheel", (event) => {
        if (event.target instanceof HTMLInputElement && event.target.type === "number") {
            event.preventDefault()
        }
    }, { capture: true, passive: false })

    const application = Application.start()
    registerCommonControllers(application)
    application.register("masked-input", MaskedInputController)
    application.register("required-repeater", RequiredRepeaterController)
    application.register("confirmation", ConfirmationController)
    application.register("form-enhancements", FormEnhancementsController)
    application.register("form-fine-print", FormFinePrintController)
    application.register("navigation", NavigationController)
    application.register("clipboard", ClipboardController)
    application.register("dialog", DialogController)
    application.register("linkify", LinkifyController)
    application.register("repeater", RepeaterController)
    application.register("datepicker", DatepickerController)
    application.register("timeslots", TimeslotsController)
    application.register("time-input", TimeInputController)
    application.register("image-selector", ImageSelectorController)
    application.register("frame-dialog", FrameDialogController)
    application.register("menu-type", MenuTypeController)
    application.register("auto-redirect", AutoRedirectController)
    application.register("tsid-decoder", TsidDecoderController)
    application.register("allergy-details", AllergyDetailsController)
    application.register("resizable-textarea", ResizableTextareaController)
    application.register("zip-code-city", ZipCodeCityController)
    application.register("bulk-actions", BulkActionsController)
    application.register("chip-picker", ChipPickerController)
    application.register("date-range-box", DateRangeBoxController)
    application.register("invite-booking", InviteBookingController)
    application.register("invite-feedback", InviteFeedbackController)
    application.register("invite-decline", InviteDeclineController)
    application.register("auto-submit", AutoSubmitController)
    application.register("send-time", SendTimeController)

    DEV: import("@foxhound-systems/annotato/stimulus").then(({ AnnotatoController }) => {
        application.register("annotato", AnnotatoController)
    })
})()

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/static/js/service-worker.js')
}
